import { render, staticRenderFns } from "./paihangbang.vue?vue&type=template&id=559b0701&scoped=true&"
import script from "./paihangbang.vue?vue&type=script&lang=js&"
export * from "./paihangbang.vue?vue&type=script&lang=js&"
import style0 from "./paihangbang.vue?vue&type=style&index=0&lang=css&"
import style1 from "./paihangbang.vue?vue&type=style&index=1&id=559b0701&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b0701",
  null
  
)

export default component.exports